/**
 * ================================================
 *
 * [content]
 *
 * ================================================
 */
let isSkip       = false,
  isPopup     = false,
  isOpen       = false,
  isAllowClose   = false,
  isDefaultFirst   = true,
  isScroll     = true,
  hHeight     = 0,
  hHeightOrg     = 0,
  hWidth       = 0,
  wIWidthOrg = 0;

let isNavOpen = false,
  isNavMainHover = new Array,
  isNavSubHover = new Array;
(function($) {
  $(function() {
    defaultFunctions.init();
    /**
     ********************************************
     * variables
     ********************************************
     */
    isSkip = $('body').hasClass('skip') ? true : false;
    isFlowAnime = $('body').hasClass('flowAnime') && !$.params.isMobile ? true : false;
    isPopup = $('body').hasClass('popup') ? true : false;
    /**
     ********************************************
     * resize event
     ********************************************
     */
    $(window).on('resize', function() {
      if ($.params.resizeTimer !== false) {
        clearTimeout($.params.resizeTimer);
      }
      $.params.resizeTimer = setTimeout(function() {
        if (isFlowAnime) {
          $('.flowVox').flowVox('destroy');
          isFlowAnime = false;
        }
        if ($.params.isChangeMode) {
          if ($.params.isRespMode && $.params.isNavOpen) {
            $('#gNavOpener').click();
          }
          defaultFunctions.init();
        } else {
          defaultFunctions.adjust();
        }
      }, 500);
    });
    /**
     ********************************************
     * scroll event
     ********************************************
     */
    $(window).on('scroll', function() {
      defaultFunctions.scrollHeader();
    });
    /**
     ********************************************
     * click event
     ********************************************
     */
    $(document).on('click', '#gNavOpener', function() {
      if ($('#navWrapper').hasClass('velocity-animating')) return;

      if ($.params.isNavOpen) {
        $('#gNavOpener, body').removeClass('open');

        $('#gNavWrapper').velocity({
          opacity: 0
        }, 250, function() {
          $('#gNavWrapper').css({
            opacity: 1,
            display: 'none'
          });

          $.params.isNavOpen = false;
        });
      } else {
        $('#gNavOpener, body').addClass('open');

        $('#gNavWrapper').css({
          opacity: 0,
          display: 'block'
        }).velocity({
          opacity: 1
        }, 250, function() {
          $.params.isNavOpen = true;
        });
      }
    });
  });
}(jQuery));
/**
 ********************************************
 * functions
 ********************************************
 */
let defaultFunctions = {
  init: function() {
    hHeightOrg = $('#siteHeader').outerHeight();

    if ($.params.dspWidth >= 768 && $.params.dspWidth <= 1024) {
      $('body').addClass('tablet');
    } else {
      $('body').removeClass('tablet');
    }

    $('.rplSPImg').replaceImageSP({
      breakPoint: $.params.spBreakPoint
    });

    $.main.ratioAdjust.init();

    setTimeout(function() {
      if (!isSkip && isFlowAnime) {
        $('.flowVox').flowVox({
          autorun: false,
          delay: 100,
          duration: 1200,
          per: $.params.wWidth > $.params.wHeight ? 0.8 : 0.95
        });
      }
      if (isPopup) $(window).popupAdjust();
      defaultFunctions.runIntro();
    }, 500);

    if ($.params.isIE) $('body').addClass('ie');
    if ($.params.isEdge) $('body').addClass('edge');

    defaultFunctions.scrollHeader();
    defaultFunctions.adjust();
  },
  adjust: function() {
    hHeight = $('#siteHeader').outerHeight();
    hWidth = $('#siteHeader').outerWidth();

    $.main.sScroll(-hHeight, 500, 'easeInQuad');
    if (hHeight !== hHeightOrg) {
      $('.scroll').off('click');
      $.main.sScroll(-hHeight, 500, 'easeInQuad');
    }

    if (!$.params.isRespMode) {
    } else {
    }

    defaultFunctions.adjustHeader();
  },
  runIntro: function() {
    if (isSkip) return;

    $('#wrapper').css({
      // opacity: 0,
      visibility: 'visible'
    });

    $('#loading').velocity('fadeOut', 500);

    if (location.hash !== '') {
      $(location.hash).velocity('stop').velocity('scroll', {
        offset: -(hHeight),
        duration: 10,
        easing: 'easeInQuad'
      });
    }

    $('#wrapper').stop().velocity({
      opacity: 1
    }, {
      delay: 400,
      duration: 500,
      complete: function() {
        if (isFlowAnime) $('.flowVox').flowVox('run');
        isDefaultFirst = false;
      }
    });
  },
  adjustHeader: function() {
  },
  scrollHeader: function() {
    var headerID = '#siteHeader';
    if ($('body').hasClass('template-index')) {
      if ($.params.scrTop > $('#mainVisual').height()) {
        $(headerID).addClass('fix');
      } else {
        $(headerID).removeClass('fix');
      }
    } else {
      if ($.params.scrTop > parseInt($('#container').css('padding-top'))) {
        $(headerID).addClass('fix');
      } else {
        $(headerID).removeClass('fix');
      }
    }
  }
};
